/* eslint-disable */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Box, TextField, Alert } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import StatusAlert from './StatusAlert';
import GoogleAuthButton from '../../../components/GoogleAuthButton/Index';

const inputSx = {
  marginTop: '5px',
  '& input::placeholder': { fontSize: '0.85rem' },
  '& .MuiOutlinedInput-root': {
    borderRadius: '30px',
    '& fieldset': {
      borderColor: 'transparent',
      backgroundColor: 'none',
      boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    '& input:-webkit-autofill': {
      boxShadow: '0 0 0 1000px #fff inset !important',
      WebkitTextFillColor: '#000 !important',
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
};
 
export default function LoginForm({
  savedEmail,
  savedPassword,
  loading,
  disableEmail,
  statusAlert,
  emailError,            
  onEmailFieldChange, 
  logoSrc,
  onSubmit,
  onForgotPassword,
  onSignUp,
  onDismissAlert,
  onGoogleSuccess,
  onGoogleError,
}) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const sanitizeEmailInput = (value) =>
  value
    .replace(/[^a-zA-Z0-9._%+@-]/g, '') 
    .replace(/([._%+-])\1{1,}/g, '$1')   
    .slice(0, 254);

const sanitizePasswordInput = (value) => value.replace(/\s/g, '').slice(0, 64);

  return (
    <Formik
      key={`${savedEmail}-${savedPassword}`}
      initialValues={{ email: savedEmail || '', password: savedPassword || '' }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .trim()
          .required('Email is required'),
         
        password: Yup.string()
          .required('Password is required.')
        
      })}
      onSubmit={onSubmit}
    >
      {({ errors, handleBlur, touched, values, setFieldValue }) => (
        <Form>
          <Grid container spacing={2} sx={{ paddingLeft: '17px' }}>
            <Grid container spacing={2}>
 
              {/* Logo + heading — hardcoded same as original */}
              <Grid item xs={12} sx={{ marginTop: '0px' }}>
                <img
                  src={logoSrc}
                  alt="logo"
                  style={{ display: 'block', margin: 'auto', height: '48px', width: '102px' }}
                />
                <Typography
                  color="#000000"
                  align="left"
                  variant="h4"
                  style={{
                    marginBottom: '6px',
                    textAlign: 'center',
                    fontFamily: 'Plus Jakarta Sans',
                    marginTop: '8px',
                  }}
                >
                  Login to your account
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{ textAlign: 'center', color: '#ababab', fontWeight: 500 }}
                >
                  Your gateway to knowledge!
                </Typography>
              </Grid>
 
              {/* Email */}
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  style={{ color: '#333', fontWeight: 500, marginLeft: '15px' }}
                  color="textSecondary"
                >
                  Email Address <span style={{ color: 'red' }}> *</span>
                </Typography>
                <TextField
                  id="curvedField"
                  fullWidth
                  placeholder={t('register_email')}
                  name="email"
                  variant="outlined"
                  color="success"
                  sx={inputSx}
                 onChange={(e) => {
                  const cleaned = sanitizeEmailInput(e.target.value);
                  setFieldValue('email', cleaned);
                  if (emailError) onEmailFieldChange?.();
                }}
                  error={Boolean((touched.email && errors.email) || emailError)}
                  helperText={ touched.email && errors.email ? t(errors.email) : emailError || ''}
                  value={values.email}
                  disabled={disableEmail}
                />
              </Grid>
 
              {/* Password */}
              <Grid item xs={12}>
                <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <Typography
                    variant="subtitle1"
                    style={{ color: '#333', fontWeight: 500, marginLeft: '15px' }}
                    color="textSecondary"
                  >
                    Password <span style={{ color: 'red' }}> *</span>
                  </Typography>
                </Box>
                <Box>
                  <TextField
                    fullWidth
                    id="curvedField"
                    sx={inputSx}
                    name="password"
                    variant="outlined"
                    color="success"
                    placeholder={t('Enter Password')}
                    type={visible ? 'text' : 'password'}
                    onBlur={handleBlur}
                    onChange={(e) => setFieldValue('password', sanitizePasswordInput(e.target.value))}
                    // onChange={(e) => setFieldValue('password', e.target.value.trim())}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password ? t(errors.password) : ''}
                    value={values.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {visible ? (
                            <VisibilityIcon
                              sx={{ color: 'grey', cursor: 'pointer' }}
                              onClick={() => setVisible(false)}
                            />
                          ) : (
                            <VisibilityOffIcon
                              sx={{ color: 'grey', cursor: 'pointer' }}
                              onClick={() => setVisible(true)}
                            />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* Forgot password — float right same as original */}
                  <Typography
                    color="#4b8efd"
                    onClick={onForgotPassword}
                    style={{
                      whiteSpace: 'nowrap',
                      paddingTop: '5px',
                      float: 'right',
                      fontSize: '12px',
                      height: 'auto',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s',
                      borderRadius: '5px',
                      textAlign: 'center',
                      marginTop: '2px',
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    {t('Forgot Password ?')}
                  </Typography>
                </Box>
              </Grid>
 
              {/* Status alert for relatedStatusId 7 / 8 / 9 */}
              {statusAlert && (
                <Grid item xs={12} sx={{ paddingTop: '4px !important', clear: 'both' }}>
                  <StatusAlert
                    alert={statusAlert}
                    onForgotPassword={onForgotPassword}
                    onDismiss={onDismissAlert}
                  />
                </Grid>
              )}
 
              {/* Buttons */}
              <Grid item xs={12} style={{ paddingTop: '0px !important', clear: 'both' }}>
                <Grid
                  container
                  spacing={2}
                  columns={{ xs: 4, md: 12 }}
                  sx={{ marginTop: '0px', paddingTop: '0px' }}
                >
                  <Grid item xs={12} container justifyContent="flex-start" style={{ paddingTop: '0px' }}>
                    <LoadingButton
                      size="medium"
                      type="submit"
                      loading={loading}
                      variant="contained"
                      sx={{
                        height: '38px',
                        paddingTop: '2px',
                        lineHeight: '1.1',
                        width: '100% !important',
                        backgroundColor: '#52c28c',
                        borderRadius: '30px',
                        marginBottom: '16px',
                        '&:hover': { backgroundColor: '#52c28c !important', color: '#fff' },
                      }}
                    >
                      {t('log In')}
                    </LoadingButton>
                  </Grid>
 
                  <Grid item xs={12} container justifyContent="flex-start" style={{ paddingTop: '0px' }}>
                    <LoadingButton
                      size="medium"
                      variant="contained"
                      sx={{
                        height: '38px',
                        paddingTop: '2px',
                        borderRadius: '30px',
                        lineHeight: '1.1',
                        width: '100%',
                        backgroundColor: '#fff',
                        border: '1px solid #52c28c',
                        color: '#444',
                        '&:hover': { backgroundColor: '#52c28c', color: '#fff' },
                      }}
                      onClick={onSignUp}
                    >
                      {t('Sign up')}
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Grid>

              {/* Google sign-in — responsive full-width, same breakpoint as the rest of the form */}
              <Grid item xs={12} sx={{ marginTop: '4px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#999',
                    mb: 1.5,
                    '&::before, &::after': {
                      content: '""',
                      flex: 1,
                      borderBottom: '1px solid #ccc',
                    },
                    '&::before': { mr: 2 },
                    '&::after': { ml: 2 },
                  }}
                >
                  <Typography variant="caption">{t('or continue with')}</Typography>
                </Box>
                <GoogleAuthButton onSuccess={onGoogleSuccess} onError={onGoogleError} />
              </Grid>

              {/* Seamless login info — uses t() same as original */}
              <Grid
                item
                xs={12}
                style={{ marginTop: '0px', paddingTop: '0 !important' }}
                sx={{ borderRadius: '5px', padding: '0px', marginTop: '10px' }}
              >
                <Alert
                  severity="info"
                  sx={{ fontSize: '10px', color: '#4B8EFD', p: 0, m: 1 }}
                >
                  {t('seamless_login_message')}
                </Alert>
              </Grid>
 
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
 